import { render, staticRenderFns } from "./inventoryStockGlassServiceSalesBreakdownWidget.vue?vue&type=template&id=180a487f&"
import script from "./inventoryStockGlassServiceSalesBreakdownWidget.vue?vue&type=script&lang=js&"
export * from "./inventoryStockGlassServiceSalesBreakdownWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports